export enum FictiveWebShop {
  BEVER_NL = '143',
  ASADVENTURE_COM = '95',
  ASADVENTURE_NL = '207',
  ASADVENTURE_FR = '189',
  ASADVENTURE_LU = '190',
  COTSWOLDOUTDOOR_COM = '62',
  SNOWANDROCK_COM = '210',
  CYCLESURGERY_COM = '211',
  RUNNERSNEED_COM = '212',
  ASADVENTURE_CO_UK = '199',
  COTSWOLDOUTDOOR_IE = '139',
  COTSWOLDOUTDOOR_US = '142',
  COTSWOLDOUTDOOR_COM_AU = '145',
  JUTTU_BE = '224',
  YAYA_BE = '229',
}
